module.exports = __webpack_public_path__ + "482479fe4701b72864242ca8ef182d02.JPG";


//////////////////
// WEBPACK FOOTER
// ./content/BRCA_scaled.JPG
// module id = 1298
// module chunks = 0